import { createTheme } from '@mui/material/styles';

// Use the Theme here to define the general Style rules of the application

const customTheme = createTheme({
  palette: {
    primary: {
      main: '#1976D2', // Your primary color
      light: '#42a5f5',
      dark: '#1565c0',
      contrastText: '#fff',
    },
    secondary: {
      main: '#9c27b0', // Your secondary color
    },
    // Add custom colors to the palette
    ochre: {
      main: '#E3D026',
      light: '#E9DB5D',
      dark: '#A29415',
      contrastText: '#242105',
    },
    backgrounds: {
        page: '#f2f2f2',
        elements: '#ffffff'
    }
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
    h1: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    color:'#111111'
    // Customize other typography variants
  },
  // Global component style overrides
  components: {
    MuiButton: {
      defaultProps: {
        disableRipple: true, // Disable ripple effect for all buttons
      },
      styleOverrides: {
        root: {
          borderRadius: 8, // Set a default border radius for all buttons
        },
      },
    },
  },
});

export default customTheme;